export default "__VITE_ASSET__OFigOBwv__"